module.exports = __webpack_public_path__ + "static/media/sigil-thumb-6-martell.dd691311.png";